import modal from './components/modal.vue';
import formModal from './components/form-modal.vue';
import formModalRow from './components/form-modal-row.vue';

export default {
	modal,
	'form-modal': formModal,
	'form-modal-row': formModalRow,
}
